const getKey = (indexEmpreendimento: number, indexSimulacao: number) => `${indexEmpreendimento}-${indexSimulacao}`

export function criarRotinaArquivoRegistry<TRotinaArquivo>() {
  const store = new Map<string, TRotinaArquivo>()

  return {
    set: (indexEmpreendimento: number, indexSimulacao: number, rotinaArquivo: TRotinaArquivo) => {
      store.set(getKey(indexEmpreendimento, indexSimulacao), rotinaArquivo)
    },

    get: (indexEmpreendimento: number, indexSimulacao: number) => {
      return store.get(getKey(indexEmpreendimento, indexSimulacao))
    },

    delete: (indexEmpreendimento: number, indexSimulacao: number) => {
      store.delete(getKey(indexEmpreendimento, indexSimulacao))
    },

    clear: () => {
      store.clear()
    },
  }
}
